import React, { Fragment, useContext } from "react";
import SelectableTable from "components/DesignSystem/SelectableTable";
import { Link, useHistory, useLocation } from "react-router-dom";
import { packClasses } from "Utils";
import { IssueListContext } from "./IssueScreen";
import { range } from "lodash";
import EmptyState from "components/DesignSystem/EmptyState";
import { SQL_DATE_FORMAT } from "helpers/Date";

export default function IssueTable(props) {
    const { items, selectedItems, loading } = useContext(IssueListContext);
    const history = useHistory();
    const location = useLocation();

    const selectAll = (e) => {
        if (e.target.checked) {
            props.setAllSelected(items.map((item) => item.uuid));
        } else {
            props.setAllSelected([]);
        }
    };

    const updateParams = (key, val = null) => {
        const params = new URLSearchParams(location.search);

        if (typeof key === "object") {
            Object.entries(key).forEach(([k, v]) => {
                params.set(k, v);
            });
        } else {
            if (params.has(key) && params.get(key) === val) {
                params.delete(key);
            } else {
                params.set(key, val);
            }
        }

        history.replace(location.pathname + "?" + params.toString());
    };

    const onSort = (sortKey) => {
        let sortDir = "desc";
        if (
            props.queryParams.has("order") &&
            props.queryParams.get("order") === sortKey
        ) {
            if (
                props.queryParams.has("dir") &&
                props.queryParams.get("dir") === "asc"
            ) {
                sortDir = "desc";
            } else {
                sortDir = "asc";
            }
        }

        updateParams({ order: sortKey, dir: sortDir });
    };

    return (
        <SelectableTable total={items.length} selected={selectedItems.length}>
            {({ innerRef }) => (
                <Fragment>
                    <thead className="bg-gray-50 ">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                                <input
                                    type="checkbox"
                                    className="appearance-none rounded text-green-700 focus:ring-green-700"
                                    ref={innerRef}
                                    onChange={(e) => selectAll(e)}
                                />
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                                <button
                                    type="button"
                                    className={packClasses(
                                        "text-xs uppercase tracking-wider",
                                        !props.queryParams.has("order") ||
                                            props.queryParams.get("order") ===
                                                "label"
                                            ? "font-bold text-gray-800"
                                            : "font-medium"
                                    )}
                                    onClick={() => onSort("label")}
                                >
                                    Label
                                </button>
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                                <button
                                    type="button"
                                    className={packClasses(
                                        "text-xs uppercase tracking-wider",
                                        props.queryParams.has("order") &&
                                            props.queryParams.get("order") ===
                                                "published_at"
                                            ? "font-bold text-gray-800"
                                            : "font-medium"
                                    )}
                                    onClick={() => onSort("published_at")}
                                >
                                    Published
                                </button>
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                                <button
                                    type="button"
                                    className={packClasses(
                                        "text-xs uppercase tracking-wider",
                                        "font-medium"
                                    )}
                                >
                                    Status
                                </button>
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                        {!loading && items.length === 0 && (
                            <tr>
                                <td colSpan={4}>
                                    <EmptyState />
                                </td>
                            </tr>
                        )}
                        {loading
                            ? range(0, 10).map((i) => (
                                  <tr className="animate-pulse" key={i}>
                                      <td
                                          className="whitespace-nowrap px-4 py-2"
                                          colSpan={4}
                                      >
                                          <div className="my-1 h-5 rounded bg-gray-300 leading-none">
                                              &nbsp;
                                          </div>
                                      </td>
                                  </tr>
                              ))
                            : items.map((item) => (
                                  <tr key={item.id}>
                                      <td className="whitespace-nowrap px-6 py-2">
                                          <input
                                              className="appearance-none rounded text-green-700 focus:ring-green-700"
                                              type="checkbox"
                                              onChange={(e) => {
                                                  props.addSelected(
                                                      e,
                                                      item.uuid
                                                  );
                                              }}
                                              checked={selectedItems.find(
                                                  (id) => id === item.uuid
                                              )}
                                          />
                                      </td>
                                      <td className="whitespace-nowrap px-6 py-2">
                                          <Link
                                              to={`/app/planner/issue/${item.uuid}`}
                                              className="color-gray-800 hover:underline"
                                          >
                                              {item.label}
                                          </Link>
                                      </td>
                                      <td className="whitespace-nowrap px-6 py-2">
                                          <Link
                                              to={`/app/planner/issue/${item.uuid}`}
                                              className="color-gray-600 text-sm hover:underline"
                                          >
                                              {item.published_at.toFormat(
                                                  SQL_DATE_FORMAT
                                              )}
                                          </Link>
                                      </td>
                                      <td className="whitespace-nowrap px-6 py-2 text-sm">
                                          {item.status ? "Active" : "Archived"}
                                      </td>
                                  </tr>
                              ))}
                    </tbody>
                </Fragment>
            )}
        </SelectableTable>
    );
}
